import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";

export const useKitchenTabletsStore = create((set, get) => ({
  tablets: [],
  pagination: null,
  isLoading: false,
  isError: false,
  error: undefined,

  // Methods
  getKitchenTablets: async (kitchenId, { page, perPage, search = "" }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      
      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }

      let response = await axiosHelper.get(
        `/kitchen/${kitchenId}/tablets?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        tablets: response?.tablets,
        pagination: response?.pagination,
        isLoading: false,
        isError: false,
      });
      return response;
    } catch (e) {
      console.log("Error fetching kitchen tablets:", e);
      set({ isError: true, error: e.message });
      return null;
    } finally {
      set({ isLoading: false });
    }
  },

  unlinkTablet: async (kitchenId, fcmToken) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      const response = await axiosHelper.post(
        `/kitchen/${kitchenId}/unlink-tablet?fcm_token=${fcmToken}`,
        {},
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // Refresh the list
      await get().getKitchenTablets(kitchenId, { page: 1, perPage: 10 });

      return true;
    } catch (e) {
      console.log("Error unlinking tablet:", e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },

  getAllTablets: async ({ page, perPage, search = "" }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      
      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }

      let response = await axiosHelper.get(
        `/kitchen/all/tablets?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        tablets: response?.tablets,
        pagination: response?.pagination,
        isLoading: false,
        isError: false,
      });
      return response;
    } catch (e) {
      console.log("Error fetching all tablets:", e);
      set({ isError: true, error: e.message });
      return null;
    } finally {
      set({ isLoading: false });
    }
  },

  getTabletsBySite: async (siteId, { page, perPage, search = "" }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      
      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }

      let response = await axiosHelper.get(
        `/kitchen/site/${siteId}/tablets?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        tablets: response?.tablets,
        pagination: response?.pagination,
        isLoading: false,
        isError: false,
      });
      return response;
    } catch (e) {
      console.log("Error fetching site tablets:", e);
      set({ isError: true, error: e.message });
      return null;
    } finally {
      set({ isLoading: false });
    }
  },

  resetState: () => {
    set({
      tablets: [],
      pagination: null,
      isLoading: false,
      isError: false,
      error: undefined,
    });
  },
}));
